import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

window.addEventListener('load', function() {
  var topSwiper = new Swiper('.swiper-container', {
    speed: 1000,
    loop: true,
    loopedSlides: 1,
    autoplay: {
      delay: 3500,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    }
  });
});
